import { NavBarInfo } from "./state";

export function initNavBarAction(state:NavBarInfo[]) {
    return {
      type: "@@NavBarAction/initNavBarAction" as const,
      state
    }
}

export function changePageAction(page:number,index:number) {
    return {
      type: "@@NavBarAction/moveToOtherNavigationBarAction" as const,
      page,
      index
    }
}


export function ChangeSurveyPageAction(surveyPage:number){
  return {
    type: "@@NavBarAction/ChangeSurveyPageAction" as const,
    surveyPage
  }
}

export function changePageWithDetailThunkAction(page:number,index:number,nav_bar_detail:string){
  return {
    type: "@@NavBarAction/changePageWithDetailThunkAction" as const,
    page,
    index,
    nav_bar_detail
  }
}



export type NavBarStateAction =
  | ReturnType<typeof initNavBarAction>
  | ReturnType<typeof changePageAction>
  | ReturnType<typeof ChangeSurveyPageAction>
   | ReturnType<typeof changePageWithDetailThunkAction>
